import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ColumnWideHalf = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path
        d="M12.834 3.1665H3.16732C2.43094 3.1665 1.83398 3.76346 1.83398 4.49984V11.4998C1.83398 12.2362 2.43094 12.8332 3.16732 12.8332H12.834C13.5704 12.8332 14.1673 12.2362 14.1673 11.4998V4.49984C14.1673 3.76346 13.5704 3.1665 12.834 3.1665Z"
        stroke={stroke || 'currentColor'}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1.83398 8H14.1673"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
      />
    </svg>
  ),
)
ColumnWideHalf.displayName = 'ColumnWideHalf'

export default ColumnWideHalf
